import axios from 'axios';

import type { GoogleUrls } from '@/constants/baseUrls';
import { trackEvents } from '@/utils/analytics';
import getEnv from '@/utils/environment';
import type { OwnHome } from '@/utils/validation/inputs';

export interface BatteryLeadFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  zip: string;
}

interface BatteryLeadProps {
  batteryData: BatteryLeadFormData;
  googleSheetUrls: GoogleUrls;
  propertyOwnership: OwnHome | undefined;
  honeypot: boolean;
}

export const submitBatteryLeadToGoogle = async ({
  batteryData,
  googleSheetUrls,
  propertyOwnership,
  honeypot,
}: BatteryLeadProps) => {
  trackEvents({
    event: 'Form Submitted',
    form_type: 'Battery Lead Form',
    ...(batteryData.email && {
      form_submit_email: batteryData.email,
    }),
    ...(propertyOwnership && {
      home_ownership: propertyOwnership,
    }),
    referral_status: 'not referred',
    honeypot,
  });

  await axios.post(googleSheetUrls[getEnv()], null, {
    params: { ...batteryData },
  });
};
